import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./styles/RedirectionPopUp.module.css";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../Context/changeLanguageProvider";

function RedirectionPopUp({
  onClose = null,
  redirect_env,
  redirect_url = undefined,
}) {
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  let current_env;
  switch (window?.location?.host) {
    case "ostreon.io":
      current_env = "US";
      break;
    default:
      current_env = window?.location?.host.split(".")[0]?.toUpperCase();
      break;
  }
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  return (
    <div className={styles.background}>
      <div className={styles.main}>
        <div onClick={onClose} className={styles.close_button} />
        <div className={styles.padding_div}>
          <div className={styles.title}>
            {dublicatedcontent?.oups_wrong_environment}
          </div>
          <div className={styles.blue_rect}></div>
          <div className={styles.body}>
            <div className={styles.body_text}>
              <div className={styles.text}>
                {dublicatedcontent?.you_are_registered_in_other_environment_but_attempted
                  ?.replace("redirect_env", redirect_env)
                  ?.replace("current_env", current_env)}
              </div>
              <div className={styles.text}>
                {dublicatedcontent?.different_continents_different_regulations}
              </div>
              <div className={styles.text}>
                {dublicatedcontent?.please_click_the_redirection_button_below}
              </div>
            </div>
            <div className={styles.redirection_logo} />
          </div>
        </div>
        <div className={styles.redirection_footer}>
          <button
            onClick={() =>
              redirect_url ? window.location.replace(redirect_url) : undefined
            }
            className={styles.blue_button}
          >
            OSTREON Inheritance {redirect_env?.toUpperCase()}
          </button>
        </div>
      </div>
    </div>
  );
}
export { RedirectionPopUp };
